import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { avgEngagementRatePerTweetConfig } from '@/lib/analytics/kpis/x/avgEngagementRatePerTweet';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerEngagementConfig: StatsConfig = {
    ...avgEngagementRatePerTweetConfig,
    id: 'engagement_rate',
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
